(() => {
  const toArray = (nodelist) => {
    return Array.prototype.slice.call(nodelist);
  };

  const handleAddedToCart = () => {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.append('inveterate-upsell-added', 'true');
    window.location.search = urlParams;
  };

  const handleAlreadyInCart = (button) => {
    const upsell = button.closest('[data-inveterate-upsell]');
    upsell.classList.add('inveterate-upsell--hidden');
  };

  const checkFreeGiftInCart = (cart, product) => {
    let inCart = false;
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      if (item.product_id === product.id) {
        inCart = true;
        break;
      }
    }

    return inCart;
  };

  const setupDeclineFreeGift = (wrapperEl, items) => {
    const button = wrapperEl.querySelector(
      '[data-inveterate-free-gift-decline]'
    );
    button.addEventListener('click', () => {
      wrapperEl.classList.add('inveterate__visible');
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(() => handleAddedToCart());
    });
  };

  const setupFreeGiftATC = (wrapperEl, variants, items) => {
    const button = wrapperEl.querySelector('[data-inveterate-atc-variant]');
    button.addEventListener('click', () => {
      const selects = toArray(
        wrapperEl.querySelectorAll('[data-inveterate-variant-option-value]')
      ).filter((el) =>
        el
          .closest('[data-inveterate-variant-option]')
          .classList.contains('inveterate__visible')
      );
      const options = selects.map((select) => select.value);

      if (options.some((option) => option === 'Select')) {
        const error = wrapperEl.querySelector(
          '[data-inveterate-free-gift-error]'
        );
        error.classList.add('inveterate__visible');
        return;
      }

      const selectedVariant = variants.find((variant) => {
        const matches = [];
        for (let i = 0; i < options.length; i++) {
          matches.push(options[i] === variant[`option${i + 1}`]);
        }
        return matches.every((match) => match);
      });

      items.push({
        id: selectedVariant.id,
        quantity: 1,
        properties: {
          _inveterate_free_signup_gift: true,
        },
      });

      wrapperEl.classList.remove('inveterate__visible');

      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(() => {
        handleAddedToCart();
      });
    });
  };

  const populateOptions = (wrapperEl, options) => {
    options.forEach((option) => {
      const optionEl = wrapperEl.querySelector(
        `[data-inveterate-variant-option="${option.position}"]`
      );
      optionEl.classList.add('inveterate__visible');
      optionEl.classList.add('inveterate__visible');
      const nameEl = optionEl.querySelector(
        '[data-inveterate-variant-option-name]'
      );
      const valuesEl = optionEl.querySelector(
        '[data-inveterate-variant-option-value]'
      );
      const name = document.createTextNode(option.name);
      const defaultOptionEl = document.createElement('option');
      defaultOptionEl.setAttribute('selected', 'selected');
      defaultOptionEl.setAttribute('hidden', 'hidden');
      defaultOptionEl.setAttribute('disabled', 'disabled');
      const defaultOptionText = document.createTextNode('Select');
      defaultOptionEl.appendChild(defaultOptionText);
      const values = option.values.map((value) => {
        const valueOptionEl = document.createElement('option');
        const valueOptionText = document.createTextNode(value);
        valueOptionEl.setAttribute('value', value);
        valueOptionEl.appendChild(valueOptionText);
        return valueOptionEl;
      });

      nameEl.appendChild(name);
      // Element.append method not supported in I.E. (in case it ever comes up)
      valuesEl.append(defaultOptionEl, ...values);
    });
  };

  const multiVariantGiftFlow = (items, product) => {
    // Get wrapper element
    const wrapperEl = document.querySelector('[data-inveterate-upsell-modal]');

    // Populate product title
    const titleEl = wrapperEl.querySelector(
      '[data-inveterate-free-gift-title]'
    );
    titleEl.appendChild(document.createTextNode(product.title));

    // Populate product image
    const imageEl = wrapperEl.querySelector(
      '[data-inveterate-free-gift-image]'
    );
    let modifiedSrc = product.image.src;
    if (modifiedSrc.indexOf('?') >= 0) {
      modifiedSrc += '&width=400';
    } else {
      modifiedSrc += '?width=400';
    }
    imageEl.setAttribute('src', modifiedSrc);

    // Populate options
    populateOptions(wrapperEl, product.options);

    // Setup ATC
    setupFreeGiftATC(wrapperEl, product.variants, items);
    // Setup Decline
    setupDeclineFreeGift(wrapperEl, items);
    // Display modal
    const modal = document.querySelector('[data-inveterate-upsell-modal]');
    modal.classList.add('inveterate__visible');
  };

  const onClick = (event) => {
    const target = event.currentTarget;
    if (target.classList.contains('inveterate-adding')) return;

    target.classList.add('inveterate-adding');
    const int = (x) => parseInt(x, 10),
      variantId = int(target.getAttribute('data-inveterate-variant')),
      sellingPlanId = int(target.getAttribute('data-inveterate-selling-plan')),
      tierId = target.getAttribute('data-inveterate-tier'),
      productHandleAttribute = target.getAttribute(
        'data-inveterate-fgsu-handle'
      ),
      tierBenefits =
        window.inveterate?.properties.tierBenefits?.find(
          (collection) => collection.segmentId === tierId
        )?.benefits || null;

    let cart;

    fetch('/cart.js')
      .then((data) => data.json())
      .then(async (response) => {
        /** â¬‡ï¸ Remove other Inveterate subscriptions if any â¬‡ï¸ */
        const inveterateSubscriptionsInCart =
          response?.items instanceof Array &&
          response.items.filter(
            (item) => item.properties?._inveterate_subscription
          );

        if (inveterateSubscriptionsInCart.length)
          for (const item of inveterateSubscriptionsInCart)
            await fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: String(item.variant_id),
                quantity: 0,
              }),
            });
        /** â¬†ï¸ Remove other Inveterate subscriptions if any â¬†ï¸ */

        cart = response;
        let itemInCart = false;
        cart.items.forEach((item) => {
          if (item.id === variantId) {
            itemInCart = true;
          }
        });

        if (itemInCart) {
          handleAlreadyInCart(target);
          return;
        }

        const items = [
          {
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: {
              _inveterate_subscription: true,
            },
          },
        ];

        const freeGiftBenefit = tierId
          ? tierBenefits?.SIGNUP_FREE_GIFT
          : window.inveterate?.properties?.benefits?.SIGNUP_FREE_GIFT;

        const productHandle =
          productHandleAttribute || freeGiftBenefit?.freeGiftProduct?.handle;

        // Add membership product to cart alone if free gwp is disabled
        if (!freeGiftBenefit || !freeGiftBenefit.enabled)
          return fetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({ items }),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(() => handleAddedToCart());

        const productResponse = await fetch(
          `/products/${productHandle}.json`
        ).then((productResponse) => productResponse.json());

        const { product } = productResponse;

        // Run single GWP variant flow
        if (product.variants.length === 1)
          return fetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({
              items: [
                ...items,
                {
                  id: product.variants[0].id,
                  quantity: 1,
                  properties: {
                    _inveterate_free_signup_gift: true,
                  },
                },
              ],
            }),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(() => handleAddedToCart());

        // Trigger multi GWP variant flow
        multiVariantGiftFlow(items, product);
      });
  };

  const initialize = () => {
    const els = toArray(document.querySelectorAll('[data-inveterate-atc]'));

    els.forEach((el) => {
      el.addEventListener('click', onClick);
    });
  };

  const interval = setInterval(() => {
    const el = document.querySelector('[data-inveterate-atc]');
    if (!el) return;
    clearInterval(interval);
    initialize();
  }, 500);
})();